<template>
<v-container fluid class="page-wrap">
    <v-row>
        <v-col
        cols="12"
        class="mb-5"
        md="12"
      >
            <v-card class="rounded-xl pa-2 pa-md-3" elevation="3">
                <v-card-title class="page-title-row">
                    <div>
                        <div class="text-overline accent--text font-weight-bold">LESSON NOTES</div>
                        <div class="text-h6 font-weight-bold primary--text">My Lesson Notes / Plans</div>
                        <div class="text-body-2 grey--text">Here you will find all your created lesson notes and plans</div>
                    </div>
                </v-card-title>
                <v-card-text>
                    <info-loader-2 v-if="fetchingContent"/>
                    <v-row v-else>
                        <v-col cols="12" md="12">
                            <v-card v-for="(record,i) in records" :key="i" outlined class="rounded-lg lesson-note-card pa-3 mb-3 d-flex align-center flex-wrap">
                                <div class="flex-grow-1">
                                    <div class="font-weight-bold primary--text">{{record.topic}}</div>
                                    <div class="text-caption grey--text">{{record.subject}} &bull; {{record.class_name}} &bull; Week {{record.week}}</div>
                                </div>
                                <div class="d-flex">
                                    <v-btn @click="editRecord(record)" icon title="update"> <v-icon color="primary">mdi-pencil-outline</v-icon>
                                    </v-btn>
                                    <v-btn @click="viewPreview(record)" icon title="view and print"> <v-icon color="accent">mdi-printer-outline</v-icon>
                                    </v-btn>
                                    <v-btn @click="deleteRecord(i)" icon title="delete"> <v-icon color="error">mdi-trash-can-outline</v-icon>
                                    </v-btn>
                                </div>
                            </v-card>
                            <v-btn @click="resetForm" outlined rounded color="primary" class="font-weight-bold text-none mt-2">
                                <v-icon left>mdi-plus</v-icon>
                                Create New
                            </v-btn>
                        </v-col>

                        <lesson-note-create-form :next="next" :record="record" :records="records" :editing="editing" v-if="showForm == true || showPreview == false" />

                        <v-col cols="12" v-else>
                            <v-card v-if="records.length > 0" outlined class="rounded-xl pa-2 pa-md-3 lesson-print-card">
                                <v-card-text class="#f5f5f5">
                                    <h1 class="text-uppercase text-center">{{record.school_name}}</h1>
                                </v-card-text>
                                <v-card-text>
                                    <h3 class="text-center primary--text">LESSON PLAN</h3>
                                    <p class="text-center"><em>Prepared By</em> <strong>{{record.teacher_name}}</strong></p>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>SUBJECT</td>
                                                <td colspan="3">{{record.subject}}</td>
                                            </tr>
                                            <tr>
                                                <td>CLASS</td>
                                                <td>{{record.class_name}}</td>
                                            </tr>
                                            <tr>
                                                <td>WEEK</td>
                                                <td>{{record.week}}</td>
                                            </tr>
                                            <tr>
                                                <td>Topic</td>
                                                <td colspan="3">{{record.topic}}</td>
                                            </tr>
                                            <tr v-if="record.subtopic">
                                                <td>Sub-topic</td>
                                                <td>{{record.subtopic}}</td>
                                            </tr>
                                            <tr v-if="record.reference_material">
                                                <td>Reference Material</td>
                                                <td>{{record.reference_material}}</td>
                                            </tr>
                                            <tr v-if="record.instructional_material">
                                                <td>Instructional Material</td>
                                                <td>{{record.instructional_material}}</td>
                                            </tr>
                                            <tr v-if="record.objectives">
                                                <td>Objectives</td>
                                                <td>{{record.objectives}}</td>
                                            </tr>
                                            <tr v-if="record.instructions">
                                                <td>Instructions</td>
                                                <td>{{record.instructions}}</td>
                                            </tr>
                                            <tr v-if="record.topic_body">
                                                <td>Body of Topic</td>
                                                <td>{{record.topic_body}}</td>
                                            </tr>
                                            <tr v-if="record.evaluation">
                                                <td>Evaluation</td>
                                                <td>{{record.evaluation}}</td>
                                            </tr>
                                            <tr v-if="record.questions">
                                                <td>Questions</td>
                                                <td>{{record.questions}}</td>
                                            </tr>
                                            <tr v-if="record.conclusion">
                                                <td>Conclusion</td>
                                                <td>{{record.conclusion}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </v-card-text>
                                <hr/>
                                <v-card-text>
                                    <h3 class="primary--text text-center">LESSON NOTE</h3>
                                    <small class="text-center mb-3">Content:</small>
                                    <p>{{record.lesson_content}}</p>
                                    <p v-if="record.files"><img :src="record.files" width="150px" class="d-inline"/></p>
                                    <v-btn
                                        fab
                                        color="primary"
                                        dark
                                        elevation="2"
                                        @click="printPreview(record)"
                                        class="noprint"
                                        >
                                        <v-icon>mdi-printer</v-icon>
                                    </v-btn>
                                </v-card-text>
                                <v-card-text class="d-none d-print-block">
                                    <p class="text-center"><small>Printed on {{new Date()}}</small><br>
                                    <small>Printed from https://teachplan.mysch.ng</small></p>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col
            cols="12"
            class="mb-5"
            md="12"
        >
                <v-card class="rounded-xl pa-2 pa-md-3" elevation="3">
                    <v-card-title class="page-title-row">
                        <div>
                            <div class="text-overline accent--text font-weight-bold">LESSON NOTES</div>
                            <div class="text-h6 font-weight-bold primary--text">Dashboard</div>
                            <div class="text-body-2 grey--text">An overview of your school lesson notes stats</div>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <info-loader-2 v-if="fetchingContent"/>
                        <v-row v-else>
                            <v-col cols="12" md="6"  v-for="(stat, i) in stats" :key="i">
                                <stat-card :count="stat.count" :title="stat.title" :icon="stat.icon"/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="mt-2">
                                <a class="link" href="https://myschng.tawk.help/article/how-to-use-the-myschng-students-results-portal" target="_blank">
                                    <v-icon small left color="primary">mdi-play-circle-outline</v-icon>
                                    Watch how the software works
                                </a>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import StatCard from '../../components/StatCard.vue';
import InfoLoader2 from '../../components/InfoLoader2.vue';
import LessonNoteCreateForm from '../../components/lessonNote/LessonNoteCreateForm.vue';
  export default {
    name: 'Dashboard',
    components: {
        StatCard,
        InfoLoader2,
        LessonNoteCreateForm
    },
    mounted() {
       if (!this.authToken) {
           this.$router.push({name: 'Login'})
       }
    },
    data: () => ({
        school: localStorage.getItem('school') ? JSON.parse(localStorage.getItem('school')) : null,
        authToken:sessionStorage.getItem('authToken') ?? null,
        stats: [],
        fetchingContent:false,
        next: 1,
        record: localStorage.getItem('mys_tcpl_record') ? JSON.parse(localStorage.getItem('mys_tcpl_record')) : {},
        records: localStorage.getItem('mys_tcpl_records') ? JSON.parse(localStorage.getItem('mys_tcpl_records')) : [],
        showForm: false,
        showPreview: true,
        editing: false,
        uuid: '11111'
    }),
    metaInfo: {
        meta: [
            { name: 'viewport', content: 'width=device-width,initial-scale=1.0' }
        ]
    },
    methods: {
        sessionStats () {
            //let loader = this.$loading.show()
            axios.get(process.env.VUE_APP_BASEURL+'/stats?school_id='+this.school.school_id,
            {
                headers:
                    {
                        'Authorization': 'Bearer '+this.authToken
                    }
            })
            .then((response) => {
                this.stats.push({
                    title:'Current session',
                    count:response.data.current_session,
                    icon:'mdi-circle-slice-5',
                })
                this.stats.push({
                    title:'Current term',
                    count:response.data.current_term,
                    icon:'mdi-pound-box',
                })
                this.stats.push({
                    title:'Total Terms Created',
                    count:response.data.total_terms,
                    icon:'mdi-timetable',
                })
            })
            .catch((error) => {
                if (error.response.status == 401) {
                    localStorage.removeItem('authToken')
                }
                this.$toast.error(error.response ? error.response.data.message : 'APP is temporarily unavailable. Wait or Contact us!', {
                    timeout: 5000
                });
            })
            .finally(() => {
                //loader.hide()
            });
        },
        editRecord(record){
           this.record = record
           this.showForm = true
           this.editing = true
           this.next = 1
        },
        deleteRecord(position){
            if (confirm("This record will be deleted from your records. Do you want to proceed?")){
                this.records.splice(position, 1)
                localStorage.mys_tcpl_records = JSON.stringify(this.records)
            }
        },
        viewPreview(record){
           this.record = record
           this.showPreview = true
           localStorage.removeItem('mys_tcpl_record')
           this.showForm = false
        },
        printPreview(){
            window.print()
        },
        resetForm(){
            if (this.records.length > 0) {
                if (confirm("This will clear any entry you have made in the form and start a fresh form for you to make another Lesson note / plan. Do you want to proceed?")){
                    this.resetRecord()
                    localStorage.removeItem('mys_tcpl_record')
                }
            }
            this.showForm = true
            this.editing = false
            this.next = 1
        },
        resetRecord(){
            this.record = {
                school_name:this.record.school_name ?? this.records[0].school_name,
                teacher_name:this.record.teacher_name ?? this.records[0].teacher_name,
                class_name:this.record.class_name ?? this.records[0].class_name,
                week:this.record.week ?? this.records[0].week,
            }
        }
    },
  }
</script>

<style scoped>
.link{
    text-decoration: none;
    font-weight: 600;
    font-size: 0.85rem;
    color: #1E3C72;
    display: inline-flex;
    align-items: center;
}
.lesson-note-card {
    border: 1px solid #ECEFF7;
}
.lesson-print-card {
    border: 1px solid #ECEFF7;
}
table{
    border-collapse: collapse;
    width: 100%;
}
table tr > td, table tr > th{
    border-top: 1px solid rgb(190, 190, 190) !important;
    border-bottom: 1px solid rgb(190, 190, 190)  !important;
    padding: 0 4px 0 4px;
}
table tbody tr td{
    font-size: 12px;
}
tr td:first-child{
    font-weight: 700;
}
td{
    white-space: pre;
}
@media print{
    .noprint{
        display: none !important
    }
}
</style>
